var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5528 12.5455L13.8075 9.48988C13.9365 7.9414 14.001 7.16716 13.5471 6.67385C13.0932 6.18054 12.3163 6.18054 10.7624 6.18054H8.23731C6.68346 6.18054 5.90654 6.18054 5.45263 6.67385C4.99872 7.16716 5.06324 7.9414 5.19228 9.48988L5.44691 12.5455C5.55774 13.8753 5.61315 14.5403 6.05169 14.9438C6.49023 15.3473 7.15747 15.3473 8.49194 15.3473H10.5078C11.8423 15.3473 12.5095 15.3473 12.9481 14.9438C13.3866 14.5403 13.442 13.8753 13.5528 12.5455Z",
    stroke: "white",
    strokeWidth: 1.14584,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.44434 6.18048V6.18048C6.44434 4.91482 7.47036 3.88879 8.73602 3.88879H10.2638C11.5295 3.88879 12.5555 4.91482 12.5555 6.18048V6.18048",
    stroke: "white",
    strokeWidth: 1.14584,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.15283 6.18054H14.8474",
    stroke: "white",
    strokeWidth: 1.14584,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.97217 10.7639L8.35412 14.9653",
    stroke: "white",
    strokeWidth: 1.14584,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0277 10.7639L10.6458 14.9653",
    stroke: "white",
    strokeWidth: 1.14584,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.f1aa479a67f9371a8c7c097e07eec76a.svg";
export { ForwardRef as ReactComponent };